export default "__VITE_ASSET__DkoOM3zE__"